import React, {Suspense, lazy, useState} from 'react';
import { LOCALES } from "./i18n/locales";
import { messages } from "./i18n/messages";
import { IntlProvider } from "react-intl";
import './App.css';
import Eingabe from "./eingabe/Eingabe";
import EingabeKulissenwerte from "./Kulissenermittlung/eingabeKulissenwerte/EingabeKulissenwerte";
import Footer from "./Footer/Footer";
import Header from "./header/Header";

import Navigation from "./nav/Nav";
import {BrowserRouter as Router, Route} from "react-router-dom";

const PDFView = lazy(() => import("./pdf/PDFView"));

function App() {
  const locale = LOCALES.GERMAN;
  const [currentLocale, setCurrentLocale] = useState(locale);

    const handleChange = (e) => {
        setCurrentLocale(e.target.value);
    };
  return (
    // <div className="App">
    //     <Header />
    //     <Eingabe />
    //     {/*<Schalldaempfer />*/}
    //     <Footer />
    // </div>

      <Router>
          <IntlProvider messages={messages[currentLocale]}
                        locale={currentLocale}
                        defaultLocale={LOCALES.GERMAN}>
          {/*<Switch>*/}
              <Header  currentLocale={currentLocale} handleChange={handleChange} />
              <Route path="/" exact component={Navigation} />
              <Route path="/schalldaempfer">
                <Eingabe currentLocale={currentLocale} />
              </Route>
              <Route path="/kulisse" exact  component={EingabeKulissenwerte}/>
              <Route path="/pdfview" exact>
                <Suspense fallback={null}>
                  <PDFView />
                </Suspense>
              </Route>
              <Footer />
          {/*</Switch>*/}
          </IntlProvider>
      </Router>

  );
}

export default App;
